import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({ hidden }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!hidden) {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  }, [pathname, hidden]);

  if (hidden) return null; // don't render at all if hidden
  return null;
};

export default ScrollToTop;
